import * as yup from 'yup';

const radioButton = {
  base: yup.string()
};
radioButton.required = radioButton.base.required('errorMessages.radioButton');
radioButton.optional = radioButton.base;

export default radioButton;
